export enum FormDisplayMode {
  SHOW,
  CREATE,
  EDIT,
}
